import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-2" };
const _hoisted_2 = { class: "grid grid-cols-2 gap-2" };
const _hoisted_3 = { class: "text-sm text-surface-900" };
const _hoisted_4 = { class: "flex gap-2 justify-end" };
const _hoisted_5 = { class: "flex items-center justify-center py-[7px] px-[10px] bg-surface-0 border border-surface-200 text-sm text-surface-600 rounded-md" };
import { ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ThresholdStepper',
    props: {
        title: {},
        selectedValue: {}
    },
    emits: ["update:selectedValue"],
    setup(__props, { emit: __emit }) {
        const thresholdOptions = ref(Array.from({ length: 41 }, (_, i) => i));
        const props = __props;
        const emit = __emit;
        const updateSelectedValue = (value) => {
            emit("update:selectedValue", value);
        };
        const minusValue = () => {
            const index = thresholdOptions.value.indexOf(props.selectedValue);
            if (index > 0) {
                updateSelectedValue(thresholdOptions.value[index - 1]);
            }
        };
        const plusValue = () => {
            const index = thresholdOptions.value.indexOf(props.selectedValue);
            if (index < thresholdOptions.value.length - 1) {
                updateSelectedValue(thresholdOptions.value[index + 1]);
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(__props.title), 1),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                            class: "flex items-center justify-center py-[7px] px-[10px] bg-surface-50 rounded-md hover:bg-surface-100 cursor-pointer",
                            onClick: minusValue
                        }, [...(_cache[0] || (_cache[0] = [
                                _createElementVNode("i", { class: "fa-solid fa-minus text-primary-700 text-sm" }, null, -1)
                            ]))]),
                        _createElementVNode("div", _hoisted_5, _toDisplayString(__props.selectedValue) + "h ", 1),
                        _createElementVNode("div", {
                            class: "flex items-center justify-center py-[7px] px-[10px] bg-surface-50 rounded-md hover:bg-surface-100 cursor-pointer",
                            onClick: plusValue
                        }, [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("i", { class: "fa-solid fa-plus text-primary-700 text-sm" }, null, -1)
                            ]))])
                    ])
                ])
            ]));
        };
    }
});
